// IMPORT JS
import * as js from "./js/front.js";